export default __webpack_public_path__ + "static/media/tosca.b2854824.svg";